import React, {
  FC
} from 'react';
import clsx from 'clsx';
import {
  useTranslation
} from 'react-i18next';

import {
  DatePickerMenu, TDate
} from 'src/features';
import {
  PopoverMenu
} from 'src/shared/components';
import {
  CalendarIcon
} from 'src/shared/icons';
import {
  formatDateRange
} from 'src/shared/utils';
import {
  languageSelectors
} from 'src/redux/language';
import {
  useTypedSelector
} from 'src/redux';

import * as Style from './HistoryDatePicker.styles';

interface DatePickerProps {
  onApply: (date: TDate[] | null) => void;
  selectedValue: TDate[] | null;
}

export const HistoryDatePicker: FC<DatePickerProps> = ({
  onApply,
  selectedValue,
}) => {
  const language = useTypedSelector(languageSelectors.getLanguage);

  const {
    t
  } = useTranslation();

  return (
    <PopoverMenu
      transparent
      placement="bottom-end"
      borderRadius={24}
      renderCustomButton={({
        isOpen, toggleMenu, triggerProps
      }) => (
        <Style.MainContainer
          {...triggerProps}
          onClick={toggleMenu}
        >
          {selectedValue ? (
            formatDateRange({
              start: selectedValue[0],
              end: selectedValue[1],
              language,
            })
          ) : (
            <Style.Placeholder>{t('select.forAllTime')}</Style.Placeholder>
          )}

          <CalendarIcon
            className={clsx({
              'text-button-blue': isOpen,
              'text-dim-gray': !isOpen,
            })}
          />
        </Style.MainContainer>
      )}
    >
      <DatePickerMenu
        onApply={onApply}
        clearButtonTitle={t('buttons.clear')}
        applyButtonTitle={t('buttons.apply')}
      />
    </PopoverMenu>
  );
};
